// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      title: '', // 面包屑标题
      search: '',
      modal1: false, // 模态框显示开关，true显示   false不显示
      addbrand: false, // 模态框显示开关，true显示   false不显示
      param: '', // 点击编辑、删除的时候对应操作的那个id
      file_url: '', // 文件路径
      file_name: '', // 文件标题
      id: '', // 标签id
      putpage: '', // 存储页数
      columns7: [
        {
          title: 'id',
          width: 100,
          key: 'id',
          render: (h, params) => h('div', [h('strong', params.row.id)]),
        },
        {
          title: '名称',
          key: 'filename',
          render: (h, params) => h('div', [h('strong', params.row.filename)]),
        },
        {
          title: '链接',
          key: 'file_url',
          render: (h, params) => h('div', [h('strong', params.row.file_url)]),
        },
        {
          title: '创建时间',
          key: 'addtime',
          render: (h, params) => h('div', [h('strong', params.row.addtime)]),
        },
        {
          title: '操作选项',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) =>
            h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.remove(params);
                    },
                  },
                },
                '删除',
              ),
            ]),
        },
      ],
    };
  },
  created() {
    const self = this;
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 300);
    const spage = this.$route.query.page;
    const asearch = this.$route.query.search;
    axios({
      method: 'post',
      url: '/admin/resource/resourceList',
      data: { page: spage, search: asearch },
    })
      .then((response) => {
        console.log(response);
        checkRule(response, self); // 检查是否有权限
        self.putpage = spage;
        self.$store.commit('getResourceParam', response.data);
      })
      .catch((response) => {
        console.log(response);
      });
  },
  // 用来获取VUEX中的文件
  computed: {
    data() {
      console.log(this.$store.state.resource.resourcelistshow);
      return this.$store.state.resource.resourcelistshow;
    },
    page() {
      console.log(this.$store.state.resource.resourcelist.total);
      return this.$store.state.resource.resourcelist.total;
    },
  },
  methods: {
    // 图片上传回调钩子方法
    handleSuccess(response) {
      checkRule(response, this); // 检查是否有权限
      if (response.code == 1) {
        this.file_url = response.imgpath;
        this.$Message.success('上传成功');
      } else {
        this.$Message.error('上传失败');
      }
    },

    // 添加品牌模态框
    addArticle() {
      this.param = '';
      this.file_url = '';
      this.addbrand = true;
    },
    // 执行添加修改品牌
    ok_addbrand() {
      const self = this;
      if (!this.file_url || !this.file_name) {
        this.$Message.error('请上传资源');
        return false;
      }
      axios({
        method: 'post',
        url: '/admin/resource/resourceUpdate',
        data: { file_url: this.file_url, file_name: this.file_name },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$store.commit(
              'getResourceParamAgain',
              self.putpage,
              self.search,
            );
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        }); //* /
    },
    // 点击取消之后走的方法
    cancel_addbrand() {
      this.addbrand = false;
    },
    // 分页的钩子函数，当跳页的时候重新请求（将页码发给后台）
    getpage(page) {
      this.putpage = page;
      const self = this;
      // 分页
      axios({
        method: 'post',
        url: '/admin/resource/resourceList',
        data: {
          page,
          search: self.search,
        },
      })
        .then((response) => {
          console.log(response);
          self.$store.commit('getResourceParam', response.data);
        })
        .catch((response) => {
          console.log('请求失败');
        });
      this.$router.push({
        path: '/resource', // 这是路由名称
        query: { page, search: self.search },
      });
    },
    /**
     * 删除当前标签
     * 同页面刷新不建议使用路由，再此请求数据
     * const定义的变量不可修改
     */
    remove(brandid) {
      this.modal1 = true;
      this.param = brandid;
    },
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/resource/resourceDel',
        data: { id: self.param.row.id },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            // self.data.splice(self.param.index, 1);//如果把那个1改成0，就是不删除
            if (self.param.index == 0 && self.putpage - 1 >= 1) {
              self.$store.commit(
                'getResourceParamAgain',
                self.putpage - 1,
                self.search,
              );
            } else {
              self.$store.commit(
                'getResourceParamAgain',
                self.putpage,
                self.search,
              );
            }
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
    cancel() {
      this.modal1 = false;
    },
  },
};
